import React from 'react'

const Fifty_four = () => {
    return (
        <div className='container'>
            <h1>C program to convert lowercase string to uppercase</h1>
            <div className='containers'>
            Example <br />

Input <br />

Input string: I love NooB Geeks. <br />
Output <br />

I LOVE NOBE GEEKS. <br />
            </div>
            <h3>Algorithm to convert lowercase to uppercase</h3>
      
            Input string from user, store it in some variable say str. <br />
Run a loop from 0 till end of string. <br />
Inside loop check if current string is lowercase then convert it to uppercase str[i] = str[i] - 32.  <br /> Now, why subtracting it with 32. Because difference of a - A = 32.
Algorithm to convert lowercase to uppercase <br />
%%Input : text &#123;Array of characters / String&#123; <br />
         N &#123;Size of the String&#123;<br />
Begin: <br />
    For i ← 0 to N do <br />
        If (text[i] &gt;= 'a' and text[i] &lt;= 'z') then<br />
            text[i] ← text[i] - 32;<br />
        End if<br />
    End for<br />
End<br />
           <div className='containers'>
         <code className='library'>  #include</code> &lt;stdio.h&gt;<br/>
  <code className='keywords'> #define</code> MAX_SIZE 100 // Maximum string size<br/>


  <code className='keywords'> int</code> main()<br/>
&#123;<br/>
      <code className='keywords'> char</code> str[MAX_SIZE];<br/>
      <code className='keywords'> int </code>i;<br/>

      <code className='comment'> /* Input string from user */<br/></code>
      <code className='library'> printf</code>("Enter your text : ");<br/>
      <code className='library'> gets</code>(str);<br/>

      <code className='keywords'> for</code>(i=0; str[i]!='\0'; i++)<br/>
    &#123;<br/>
          <code className='comment'> /*<br/>
         * If current character is lowercase alphabet then<br/>
         * convert it to uppercase.<br/>
         */<br/></code>
          <code className='library'> if</code>(str[i]&gt;='a' && str[i]&lt;='z')<br/>
        &#123;<br/>
            str[i] = str[i] - 32;<br/>
        &#125;<br/>
    &#125;<br/>

      <code className='library'> printf</code>("Uppercase string : %s",str);<br/>
      <code className='library'> return 0</code>;<br/>
&#125;<br/>
           </div>
        </div>
    )
}

export default Fifty_four
